import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import Buefy from "buefy";
import VueHead from "vue-head";
require("@/assets/style/buefy.scss");

/* eslint-disable */

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(Buefy);
Vue.use(VueHead);

Vue.mixin({
  methods: {
    sendGa(action: string, category: string, label: string): void {
      this.$gtag.event(action, { 'event_category': category, 'event_label': label });
    },
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
